import { Container } from 'react-bootstrap';

const MySchedule = () => {
  return (
    <Container>
      <h2>My Schedule</h2>
      {/* Add your schedule viewing content here */}
    </Container>
  );
};

export default MySchedule;